import { useLocation, useNavigate } from 'react-router-dom';

interface SectionTabsProps {
  title: string;
  tabs: { title: string; url: string }[];
}

// 대제목 + 소제목 탭 (새삶이야기, 후원 등)
export default function SectionTabs({ title, tabs }: SectionTabsProps) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="homepage_detail_titlebox">
      <p className="homepage_detail_title">{title}</p>
      <div className="section-tabs">
        {tabs.map((tab) => (
          <button
            type="button"
            key={tab.url}
            className={`section-tab ${location.pathname === tab.url ? 'is-on' : ''}`}
            onClick={() => navigate(tab.url)}
          >
            {tab.title}
          </button>
        ))}
      </div>
    </div>
  );
}
